var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFrameInner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 342
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.189 41.48h-30.982a3.819 3.819 0 01-2.795-1.265 126.186 126.186 0 00-184.761 0 3.818 3.818 0 01-2.795 1.265H3.811A3.8 3.8 0 000 45.28v251.46a3.8 3.8 0 003.811 3.787h31.045a3.814 3.814 0 012.795 1.266 126.211 126.211 0 00184.761 0 3.816 3.816 0 012.795-1.266h30.982a3.807 3.807 0 003.811-3.795V45.276a3.806 3.806 0 00-3.811-3.8z",
    fill: "#003c3b"
  })));
}

export default __webpack_public_path__ + "ed5e7c48e4185c0595485221d4e7824b.svg";
export { SvgFrameInner as ReactComponent };